import React from 'react'
import Paper from 'material-ui/Paper'
import { themeColors } from '../../styles/theme'
import VerifiedUser from 'material-ui/svg-icons/action/verified-user'
import { styles } from './Styles'
import {
  Table,
  TableBody,
  TableHeaderColumn,
  TableRow,
  TableRowColumn,
} from 'material-ui/Table'
import { Link } from 'react-router-dom'

const GuidaSicurezza = () => (
  <Paper style={styles.paper}>
    <div>
      <h4 style={styles.titles}>
        <VerifiedUser style={styles.titleIcon} />
        Guida alla Sicurezza
      </h4>
      <p>
        La Community di swapick.com è regolata dagli Utenti attraverso il sistema dei feedback. Infatti, al termine di ogni scambio, è possibile rilasciare il proprio giudizio (feedback) e la valutazione può andare da un minimo di 1 stellina (molto negativo), ad un massimo di 5 stelline (molto positivo).
      </p>
      <p>
        Prima di fare una proposta di scambio è molto importante controllare sempre l'indice di affidabilità che tiene conto del peso dell’Utente all’interno della Community proprio grazie ai feedback ricevuti dagli altri Utenti. Più la percentuale è alta e più l’utente è affidabile.
      </p>
      <Table
        style={{
          border: '1px solid #E0E0E0',
          backgroundColor: themeColors.lightBackground,
        }}>
        <TableBody displayRowCheckbox={false}>
          <TableRow>
            <TableHeaderColumn style={styles.tableTitle}>
              Fasce %
            </TableHeaderColumn>
            <TableHeaderColumn style={styles.tableTitle}>
              Indice di affidabilità
            </TableHeaderColumn>
          </TableRow>
          <TableRow style={styles.tableRow}>
            <TableRowColumn style={styles.tableLeft}>
              96% - 100%
            </TableRowColumn>
            <TableRowColumn style={styles.tableRight}>
              A Affidabile
            </TableRowColumn>
          </TableRow>
          <TableRow style={styles.tableRow}>
            <TableRowColumn style={styles.tableLeft}>
              90% - 95%
            </TableRowColumn>
            <TableRowColumn style={styles.tableRight}>
              B Abbastanza affidabile
            </TableRowColumn>
          </TableRow>
          <TableRow style={styles.tableRow}>
            <TableRowColumn style={styles.tableLeft}>
              80% - 89%
            </TableRowColumn>
            <TableRowColumn style={styles.tableRight}>
              C Non sempre affidabile
            </TableRowColumn>
          </TableRow>
          <TableRow style={styles.tableRow}>
            <TableRowColumn style={styles.tableLeft}>
              70% - 79%
            </TableRowColumn>
            <TableRowColumn style={styles.tableRight}>
              D Poco affidabile
            </TableRowColumn>
          </TableRow>
          <TableRow style={styles.tableRow}>
            <TableRowColumn style={styles.tableLeft}>
              1% - 69%
            </TableRowColumn>
            <TableRowColumn style={styles.tableRight}>
              E Inaffidabile
            </TableRowColumn>
          </TableRow>
        </TableBody>
      </Table>
      <p
        style={{
          color: themeColors.energized,
          fontWeight: 'bold',
          textTransform: 'uppercase',
        }}>
        Eccezioni:
      </p>
      <p
        style={{
          color: themeColors.neutral,
          fontStyle: 'italic',
        }}>
        <small>
          PA Utente poco attivo*<br />
          NA  Utente non attivo**<br />
          NI  Utente nuovo iscritto***<br />
          * meno di 3 scambi negli ultimi 12 mesi<br />
          ** nessuno scambio concluso negli ultimi 12 mesi<br />
          *** iscritto da meno di 30 giorni
        </small>
      </p>
      <p>
        Un Utente appena iscritto (e quindi con zero feedback), per poter crescere rapidamente nella Community, dovrà fare proposte ad Utenti affidabili (fascia A). L'indice di affidabilità verrà calcolato solo se l'Utente si dimostra attivo (vedi “eccezioni”).
        <br />
        Ogni Utente dovrà sempre fare molta attenzione a non ricevere giudizi negativi, altrimenti il suo indice di affidabilità potrebbe ridursi drasticamente e di conseguenza si ridurrebbero le sue possibilità di scambio.
        <br />
        Ti invitiamo pertanto, a controllare sempre l’indice di affidabilità  prima di ogni scambio e ad osservare le regole della Community.
        <br />
        In caso di compravendita, consigliamo sempre ad acquirenti e venditori di
        {' '}
        <strong>incontrarsi di persona</strong>
        {' '}
        in luoghi pubblici e di effettuare la consegna e il pagamento dell'oggetto soltanto dopo un'accurata ispezione dell'articolo stesso da parte dell'acquirente o, in alternativa, di utilizzare un metodo di pagamento sicuro, come ad esempio
        {' '}
        <strong>PayPal</strong>
        , evitando sempre assegni, trasferimenti con Western Union o altri tipi di bonifici.
      </p>
      <p>
        Nel caso invece di un baratto, per una maggiore sicurezza negli scambi, è molto importante seguire una semplice regola: L’Utente con l’indice di affidabilità più basso è tenuto sempre a spedire per primo.
        <br />
        A parità di fascia di affidabilità spedirà per primo l’utente con meno transazioni di scambio totali e a parità anche del numero di transazioni spedirà per primo chi propone lo scambio.
      </p>
      <p
        style={{
          color: themeColors.energized,
          fontWeight: 'bold',
          textTransform: 'uppercase',
        }}>
        Esempi:
      </p>
      <p>
        <span style={{ color: themeColors.energized }}>
          Caso 1
        </span>
        :
        <br />
        <span style={styles.underPositive}>
          Utente che propone lo scambio: Fascia di affidabilità B e 100 scambi effettuati
        </span>
        <br />
        <span style={styles.underSecondary}>
          Utente che accetta lo scambio: Fascia di affidabilità A e 100 scambi effettuati
        </span>
        <br />
        In questo caso spedirà per primo l'Utente che propone lo scambio perché la fascia di affidabilità è più bassa.
      </p>
      <p>
        <span style={{ color: themeColors.energized }}>
          Caso 2
        </span>
        :
        <br />
        <span style={styles.underPositive}>
          Utente che propone lo scambio: Fascia di affidabilità A e 100 scambi effettuati
        </span>
        <br />
        <span style={styles.underSecondary}>
          Utente che accetta lo scambio: Fascia di affidabilità A e 10 scambi effettuati
        </span>
        <br />
        In questo caso spedirà per primo l'Utente che accetta lo scambio perché, a parità di fascia di affidabilità, ha un numero inferiore di transazioni di scambio. Qualora le differenze nel numero di transazioni di scambio siano minime, lasciamo comunque un margine di discrezionalità agli Utenti e quindi anche la possibilità di decidere se spedire contemporaneamente.
      </p>
      <p>
        <span style={{ color: themeColors.energized }}>
          Caso 3
        </span>
        :
        <br />
        <span style={styles.underPositive}>
          Utente che propone lo scambio: Fascia di affidabilità A e 10 scambi effettuati
        </span>
        <br />
        <span style={styles.underSecondary}>
          Utente che accetta lo scambio: Fascia di affidabilità B e 100 scambi effettuati
        </span>
        <br />
        In questo caso spedirà per primo l'Utente che accetta lo scambio perché, nonostante il maggior numero di scambi, la fascia di affidabilità è più bassa.
      </p>
      <p>
        <span style={{ color: themeColors.energized }}>
          Caso 4
        </span>
        :
        <br />
        <span style={styles.underPositive}>
          Utente che propone lo scambio: Fascia di affidabilità A e 100 scambi effettuati
        </span>
        <br />
        <span style={styles.underSecondary}>
          Utente che accetta lo scambio: Fascia di affidabilità A e 100 scambi effettuati
        </span>
        <br />
        In questo caso, a pari fascia di affidabilità e pari numero di transazioni di scambio, spedirà per primo l'Utente che propone lo scambio. Lasciamo comunque un margine di discrezionalità agli Utenti e quindi anche la possibilità di decidere se spedire contemporaneamente.
      </p>
      <p>
        Ti suggeriamo, quindi, di aspettare sempre di ricevere l’oggetto dell’altro Utente, qualora quest'ultimo abbia una fascia di affidabilità più bassa della tua o, a pari fascia di affidabilità, abbia meno transazioni di scambio rispetto a te. Aspettando di ricevere l'oggetto, il massimo rischio che potrai correre sarà quello di non concludere la transazione nel caso in cui l'altro Utente non spedisca, ma almeno sarai sicuro di non perdere il tuo oggetto.
        <br />
        Inoltre, al fine di rendere maggiormente sicure le transazioni e per agevolare gli utenti appena registrati (zero feedback), c’è la localizzazione per provincia. Sul sito è infatti possibile individuare facilmente gli utenti geograficamente più vicini per effettuare uno scambio a mano.
        <br />
        Swapick agevola la compravendita e il baratto fra gli Utenti, ma non svolge nessun ruolo di intermediazione, dunque non può entrare nel merito delle singole transazioni né esserne il garante. L’assistenza diretta nelle transazioni perciò non è prevista, ma è possibile un supporto (facoltativo) da parte dello staff qualora ve ne fosse realmente necessità. Tale supporto è a totale discrezione dello staff di Swapick.
        <br />
        Per approfondimenti sulle regole del sito e sui termini di legge vedi “
        <Link to="">termini e condizioni d’uso</Link>
        ”.
      </p>
    </div>
  </Paper>
)

export default GuidaSicurezza



// WEBPACK FOOTER //
// ./src/common/Infotext/GuidaSicurezza.js